/**
 * Conditionally log based on `window.enableScannerLogging`
 * @param  {...any} args console.log(...args)
 */
export const scannerLog = (...args) =>
  window.enableScannerLogging && console.log(...args);
